import { Button } from "@mui/material";
import { useHistory } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
const BackButton = ({ buttonIcon, backUrl }) => {
  const history = useHistory();
  return (
    <div className="d-flex justify-content-start">
      {buttonIcon === "yes" ? (
        <Button
          variant="icon"
          color="error"
          title="Back To Upload"
          onClick={() => {
            history.push(backUrl);
          }}
        >
          <KeyboardBackspaceIcon style={{ color: "rgb(211, 47, 47)" }} />
        </Button>
      ) : (
        <Button
          variant="outlined"
          color="error"
          onClick={() => {
            history.push(backUrl);
          }}
        >
          Back
        </Button>
      )}
    </div>
  );
};

export default BackButton;
